import {
  Environment
} from '@vodacom/web-env';

import {
  AppState
} from 'helpers';

export class FupProvider {

  static BASE_URL = Environment.current.apiHost;
  static STATE = AppState.with('FupProvider');

  static async registerStudentFup(
    fname,
    lname,
    id,
    msisdn
  ) {

    return FupProvider.STATE.makeServiceCall(
      `${FupProvider.BASE_URL}/fup/registration`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'firstName': fname,
          'lastName': lname,
          'idNumber': id,
          'msisdn': msisdn
        }
      }
    )
      .then((res) => {
        if (!res.result) {
        return {
            ok: false,
            error: new Error('TODO: Add here'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }
        return res;
      })
      .catch((error) => {
        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: error.response.status,
          stamp: new Date()
        };
      });
  }

}
